@for (variant of variants; track variant; let i = $index; let last = $last) {
  @if (colorSet[variant]; as color) {
    <div
      [style.background-color]="color"
      (click)="select.emit(color)"
      (keyup.enter)="select.emit(color)"
      [ngClass]="{ last: last, light: i > 4, selected: color === value }"
      tabindex="0"
      class="box"
    >
      @if (activeColors.includes(color)) {
        <i class="myre-icon-check"></i>
      }
    </div>
  }
}
